import React, { useState, useRef } from "react";
import MapGL, { NavigationControl } from "react-map-gl";
import Icon from "../icon"
import useMap from "./logic";
import Marker from "./marker";
import LodgingSliderCell from "./lodginSlider";
import * as styles from "./index.module.scss"
import LodgingMarker from "./lodgingMarker";

import 'mapbox-gl/dist/mapbox-gl.css';

const TOKEN = process.env.MAPBOX_TOKEN || "pk.eyJ1Ijoic3BvdGxpbyIsImEiOiJjbGZjOTN0ZmYwNGZtM3BwMDJ4ZGYxeXhlIn0.Cm5ThR-UvcADRTOOD_RV6Q";
let startX;
let scrollLeft;

const Map = ({
  suppliers,
  update,
  className,
  mapPadding,
  color,
  viewToggle,
  toggleValue,
  hasSlider = false,
  markersType = "default",
  subField = undefined,
  selectedLanguage,
  getLinkToSupplierPage,
  buttonListText = "List",
  buttonFiltersText = "Filters",
  buttonStyles = "",
  isPackage = false,
  onMarkerSelected = () => null
}) => {
  const [selectedLodging, setSelectedLodging] = useState(false);
  const { viewport, points, setViewport } = useMap(suppliers, mapPadding, subField, selectedLodging);

  const [isDown, setIsDown] = useState(false);
  const slider = useRef(null);

  const renderMarkers = () => {
    const hasSearched = points && points[0] && points[0].price;
    if (markersType !== "default" && hasSearched) {
      return points.map((point, idx) => {
        const id = `lodging_slider_cell_${idx}`;
        return (
          <LodgingMarker
            key={id}
            marker={point}
            id={id}
            selected={true}
            setSelectedLodging={setSelectedLodging}
          />
        );
      });
    }
    return points.map((point, index) => {
      return (
        <Marker key={`marker_point_${index}`} color={color} marker={point} onMarkerClick={(index) => {
          onMarkerSelected(index);
          // setSelectedLodging(`lodging_slider_cell_${index}`)
        }
        } />
      );
    });
  };

  const sliderOnMouseDown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    setIsDown(true);
    slider.current.classList.add("active");
    startX = e.pageX - slider.current.offsetLeft;
    scrollLeft = slider.current.scrollLeft;
  };

  const sliderOnMouseUp = () => {
    setIsDown(false);
    slider.current.classList.remove("active");
  };

  const sliderOnMouseMove = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    if (!isDown) return;
    const x = e.pageX - slider.current.offsetLeft;
    const walk = (x - startX) * 3;
    slider.current.scrollLeft = scrollLeft - walk;
  };

  return (
    <div className={`relative ${className}`}>
      <MapGL
        dragPan={update !== false && true}
        touchZoom={update !== false && true}
        scrollZoom={update !== false && true}
        doubleClickZoom={update !== false && true}
        {...viewport}
        onViewportChange={(nextViewport) => setViewport(nextViewport)}
        width={"100%"}
        height={"100%"}
        mapStyle="mapbox://styles/mapbox/outdoors-v11"
        mapboxApiAccessToken={TOKEN}
      >
        {update && (
          <div style={{ position: "absolute", left: 15, top: 15, zIndex: 1 }}>
            <NavigationControl onViewportChange={(nextViewport) => setViewport(nextViewport)} />
          </div>
        )}
        {renderMarkers()}
      </MapGL>
      {hasSlider ? (
        <>
          {toggleValue === "map" && (
            <div className={styles.sliderWrapper}>
              <button className={`rounded-2xl lg:hidden flex items-center text-sm p-4 w-44 h-10 justify-center absolute bottom-3 left-1/2 -translate-x-1/2 ${buttonStyles}`} onClick={() => viewToggle('list')}>
                <span className="flex gap-2 items-center">
                  <Icon icon="Globe" className="w-4 h-4 text[color:var(--primaryColor)]" />
                  {/* {view !== 'list' ? 'List' : 'Map'} */}
                  {buttonListText}
                </span>
                {/* |
                <span className="flex gap-2 items-center">
                  <Icon icon="Filter" className="w-4 h-4" />
                  {buttonFiltersText}
                </span> */}
              </button>
              <div
                className={`${styles.lodgingSlider} lodging-map-slider`}
                ref={slider}
                tabIndex={-1}
                onMouseDown={sliderOnMouseDown}
                onMouseMove={sliderOnMouseMove}
                onMouseUp={sliderOnMouseUp}
                onMouseLeave={sliderOnMouseUp}
              >
                {points.map((point, idx) => {
                  const id = `lodging_slider_cell_${idx}`;
                  return (
                    <LodgingSliderCell
                      isPackage={isPackage}
                      lodgingId={id}
                      key={id}
                      getLinkToSupplierPage={getLinkToSupplierPage}
                      marker={point}
                      id={idx}
                      selected={id === selectedLodging}
                      setSelectedLodging={setSelectedLodging}
                      selectedLanguage={selectedLanguage}
                    />
                  );
                })}
              </div>
            </div>
          )}
        </>
      ) : null}
    </div>
  );
};

export default Map;